import { render, staticRenderFns } from "./recordsDetail.vue?vue&type=template&id=6cb2fa30&scoped=true"
import script from "./recordsDetail.vue?vue&type=script&lang=js"
export * from "./recordsDetail.vue?vue&type=script&lang=js"
import style0 from "./recordsDetail.vue?vue&type=style&index=0&id=6cb2fa30&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb2fa30",
  null
  
)

export default component.exports